/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Cookies_Essential_DescInputs */

const en_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication session tokens required for the service to function. No consent needed.`)
};

const de_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierungs-Sitzungs-Tokens, die fuer den Betrieb des Dienstes erforderlich sind. Keine Einwilligung erforderlich.`)
};

const fr_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetons de session d'authentification nécessaires au fonctionnement du service. Aucun consentement requis.`)
};

const es_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens de sesión de autenticación necesarios para el funcionamiento del servicio. No se requiere consentimiento.`)
};

const it_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token di sessione di autenticazione necessari per il funzionamento del servizio. Non è richiesto il consenso.`)
};

const nl_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticatiesessietokens die nodig zijn voor het functioneren van de dienst. Geen toestemming nodig.`)
};

const pl_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokeny sesji uwierzytelniania wymagane do funkcjonowania usługi. Zgoda nie jest wymagana.`)
};

const fi_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todennusistunnon tunnisteet, jotka ovat välttämättömiä palvelun toiminnalle. Suostumusta ei tarvita.`)
};

const da_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autentificeringssessionstokens, der er nødvendige for, at tjenesten fungerer. Intet samtykke nødvendigt.`)
};

const sv_privacy_cookies_essential_desc = /** @type {(inputs: Privacy_Cookies_Essential_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autentiseringstoken som krävs för att tjänsten ska fungera. Inget samtycke behövs.`)
};

/**
* | output |
* | --- |
* | "Authentication session tokens required for the service to function. No consent needed." |
*
* @param {Privacy_Cookies_Essential_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_cookies_essential_desc = /** @type {((inputs?: Privacy_Cookies_Essential_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Cookies_Essential_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_cookies_essential_desc(inputs)
	if (locale === "fr") return fr_privacy_cookies_essential_desc(inputs)
	if (locale === "es") return es_privacy_cookies_essential_desc(inputs)
	if (locale === "it") return it_privacy_cookies_essential_desc(inputs)
	if (locale === "nl") return nl_privacy_cookies_essential_desc(inputs)
	if (locale === "pl") return pl_privacy_cookies_essential_desc(inputs)
	if (locale === "fi") return fi_privacy_cookies_essential_desc(inputs)
	if (locale === "da") return da_privacy_cookies_essential_desc(inputs)
	if (locale === "sv") return sv_privacy_cookies_essential_desc(inputs)
	return en_privacy_cookies_essential_desc(inputs)
});